import en from '../public/lang/en.json';
import ar from '../public/lang/ar.json';
import ur from '../public/lang/ur.json';

export const messages = { en, ar, ur };

export const locales = [
  {
    name: 'English',
    key: 'en',
    dir: 'ltr',
  },
  {
    name: 'العربية',
    key: 'ar',
    dir: 'rtl',
    disabled: false,
  },
  {
    name: 'اردو',
    key: 'ur',
    dir: 'rtl',
    disabled: true,
  },
];
